import React from 'react';
import { colors } from '../constants';

const ScorecardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
  >
    <path
      fill={props.color}
      d="M.28 10C.28 4.615 4.643.25 10.03.25c5.384 0 9.75 4.365 9.75 9.75s-4.366 9.75-9.75 9.75c-1.726 0-3.386-.45-4.848-1.288l-.154.043c.14-.04-.778.223-1.06.3-.113.033-.223.063-.33.09-1.778.478-2.165.547-2.6.063-.388-.432-.32-.854.092-2.57l.082-.334c.07-.28.29-1.13.277-1.086l.044-.18C.716 13.342.28 11.703.28 10zm2.97 7.448l.318-.087c.274-.075 1.186-.337 1.05-.298.164-.046.277-.078.364-.1.072-.017.105-.025.147-.033.042-.008.042-.008.11-.015.086-.018.086-.018.462.11 1.29.797 2.776 1.225 4.327 1.225 4.555 0 8.25-3.694 8.25-8.25s-3.695-8.25-8.25-8.25c-4.557 0-8.25 3.694-8.25 8.25 0 1.526.413 2.99 1.186 4.267.124.357.124.357.11.44-.006.066-.006.066-.013.11-.006.042-.016.09-.03.148-.02.09-.047.206-.09.373.01-.04-.207.805-.275 1.078l-.08.325c-.086.36-.155.668-.203.92.24-.05.53-.122.866-.212zm4.02-7.685l1.454 1.54 4.323-3.995c.304-.282.78-.263 1.06.04.28.306.262.78-.042 1.06l-4.872 4.503c-.303.28-.776.263-1.058-.04L6.17 10.787c-.28-.304-.264-.778.04-1.06.302-.283.777-.266 1.06.037z"
    />
  </svg>
);

ScorecardIcon.defaultProps = {
  color: colors.mediumGrey,
};

export default ScorecardIcon;
